import React from 'react';
import {useTranslation} from "@Translation/hooks/useTranslation";
import Column from "@Containers/components/Column";
import Row from "@Containers/components/Row";
import useIsMobile from "@Hooks/selector/useIsMobile";
import IconChevron from "@Icons/chevrons/IconChevron";
import {Colors} from "@Styles/Colors.style";
import getRedeemCompanies from "@MyVoucher/functions/getRedeemCompanies";

interface VoucherStatusProps {
    companyList: string[]
    isOpened: boolean,
}

function VoucherStatusInfo({companyList, isOpened}: VoucherStatusProps) {
    const {
        redeem: redeemLabel,
        limitations_may_apply: limitationsMayApplyLabel,
    } = useTranslation('my_profile.my_vouchers')

    const isMobile = useIsMobile()

    return (
        <Column className="voucher-status info-field-medium">
            <Row className="gb--emphasize-default" justify>
                {`${redeemLabel} ${getRedeemCompanies(companyList)}`}
                {isMobile && (
                    <IconChevron
                        chevronOrientation={isOpened ? "up" : "down"}
                        height="22px"
                        width="22px"
                        fill={Colors.primaryColor}
                    />
                )}
            </Row>
            {!isMobile && (
                <div>{limitationsMayApplyLabel}</div>
            )}
        </Column>
    );
}

export default VoucherStatusInfo;